import { Map } from 'immutable';
import { createReducer } from 'utils/redux';
import { actionTypes } from './actions';

const initialState = Map({
  loading: false,
  error: null,
  data: null,
});

const onStart = () =>
  Map({
    loading: true,
    data: null,
    error: null,
  });

const onSuccess = (state, { payload }) =>
  Map({
    loading: false,
    data: payload,
    error: null,
  });

const onError = (state, { payload }) =>
  Map({
    loading: false,
    data: null,
    error: payload,
  });

export default createReducer(initialState, {
  [actionTypes.SELF_INSURANCE_TAXES_REQUEST_START]: onStart,
  [actionTypes.SELF_INSURANCE_TAXES_REQUEST_SUCCESS]: onSuccess,
  [actionTypes.SELF_INSURANCE_TAXES_REQUEST_FAILURE]: onError,
});
